import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/Login.css';
import obraswiseLogo from '../assets/obraswise-logo.png';
// Removido import do Firebase Auth
// import { auth } from '../firebase/config';
// import { signInWithEmailAndPassword } from 'firebase/auth';

// Importar nosso serviço de API
import { apiService } from '../services/ApiService';
import { useAuth } from '../contexts/AuthContext';
import { useTheme } from '../contexts/ThemeContext';
import { FiSun, FiMoon } from 'react-icons/fi';
import RecuperarSenha from './RecuperarSenha';

const Login = ({ onRegisterClick, onLoginSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [showRecuperarSenha, setShowRecuperarSenha] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();
  const { darkMode, toggleTheme } = useTheme();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    // Validação básica do campo de usuário
    if (!username.trim()) {
      setError('Por favor, insira seu nome de usuário ou email');
      setLoading(false);
      return;
    }

    try {
      const result = await login(username.toLowerCase().trim(), password);
      
      if (result.success) {
        if (result.isOffline) {
          alert('Você está logado em modo offline. Algumas funcionalidades podem estar limitadas até que a conexão com o servidor seja restabelecida.');
        }
        
        const user = apiService.getCurrentUser();
        
        if (user.role === 'inativo') {
          navigate('/subscription', { replace: true });
        } else {
          navigate('/home', { replace: true });
        }
        
        if (onLoginSuccess) {
          onLoginSuccess(user);
        }
      } else {
        setError(result.error || 'Usuário ou senha inválidos');
      }
    } catch (error) {
      setError('Ocorreu um erro ao fazer login. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  const handleRegisterClick = () => {
    if (typeof onRegisterClick === 'function') {
      onRegisterClick();
    }
  };

  const handleRecuperarSenhaClick = () => {
    setShowRecuperarSenha(true);
  };

  const handleBackToLogin = () => {
    setShowRecuperarSenha(false);
    setError('');
  };

  if (showRecuperarSenha) {
    return <RecuperarSenha onBackToLogin={handleBackToLogin} />;
  }

  return (
    <div className={`login-container ${!darkMode ? 'light-mode' : ''}`}>
      <div className="login-card">
        <div className="theme-toggle">
          <button 
            className="theme-button" 
            onClick={toggleTheme} 
            aria-label={darkMode ? "Mudar para tema claro" : "Mudar para tema escuro"}
          >
            {darkMode ? <FiSun /> : <FiMoon />}
          </button>
        </div>
        
        <div className="logo-container">
          <img src={obraswiseLogo} alt="Obraswise" className="logo" />
        </div>
        <h2 className="title">Obraswise</h2>
        
        <form onSubmit={handleSubmit} className="login-form">
          {error && <div className="error-message">{error}</div>}
          <div className="form-group">
            <label>Usuário ou Email</label>
            <input 
              type="text" 
              placeholder="Digite seu usuário ou email" 
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required 
              disabled={loading}
            />
            <small className="help-text">Você pode fazer login usando seu nome de usuário ou email cadastrado</small>
          </div>
          <div className="form-group">
            <label>Senha</label>
            <input 
              type="password" 
              placeholder="Digite sua senha" 
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required 
              disabled={loading}
            />
            <button 
              type="button" 
              className="forgot-password-link" 
              onClick={handleRecuperarSenhaClick}
              disabled={loading}
            >
              Esqueceu a senha?
            </button>
          </div>
          <button type="submit" className="login-button" disabled={loading}>Entrar</button>
          <button 
            type="button" 
            className="register-button" 
            onClick={handleRegisterClick}
            disabled={loading}
          >
            Não tem conta? Cadastre-se
          </button>
        </form>
        
        {loading && (
          <div className="loading-container">
            <div className="loading-spinner"></div>
            <p className="loading-text">Verificando conexão com o servidor...</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Login; 